import { BrowserRouter as Router } from "react-router-dom";
import { MainContextProvider } from "./contexts/MainContext";
import Header from "./components/header/Header";
import HeaderEmptyVoid from "./components/header-empty-void/HeaderEmptyVoid";
import AnimatedRoutes from "./router/AnimatedRoutes";

import './styles.scss'

export default function AppRouter() {
    // Uncomment for production
    // document.addEventListener('contextmenu', event => event.preventDefault());

    return (
        <Router>
            <MainContextProvider>
                <Header />
                <HeaderEmptyVoid />
                <AnimatedRoutes />
            </MainContextProvider>
        </Router>
    );
}
